import api from 'api'
import { WorkShift } from 'api/typings'

export type GetAdminShiftsParams = {
  type?: 'upcoming' | 'past' | 'ongoing'
  startDate?: string
  endDate?: string
  companyIds?: number[]
  shiftId?: number | string
  market?: string
  isUnfilled?: boolean
}

type GetAdminShiftsResult = {
  data: { admin: { shifts: WorkShift[] } }
}

export async function getShifts(params: GetAdminShiftsParams) {
  const body: Record<string, unknown> = {
    grouping: params.type,
    ...(params.startDate && { startDate: params.startDate }),
    ...(params.endDate && { endDate: params.endDate }),
    ...(params.companyIds &&
      params.companyIds.length > 0 && {
        companyIds: params.companyIds.map(Number),
      }),
    ...(params.shiftId !== undefined && {
      shiftId: String(params.shiftId),
    }),
    ...(params.market && { market: params.market }),
    ...(params.isUnfilled === true && { isUnfilled: true }),
  }

  const response = await api.post<GetAdminShiftsResult>(
    '/admin/graphql_dispatch/admin_shifts_a7b8c9d0',
    body
  )
  return response.data.data.admin.shifts
}
